<main>
	<section class="light-tile-container">
		<span></span>
		<div class="light-tile-content">
			<div class="img">
				<img
					ngSrc="../../../../assets/img/visec_logo.png"
					alt="Logo"
					width="280"
					height="60"
					priority
				/>
			</div>
			<div class="signin">
				<app-title
					title="Bienvenido a la plataforma ViSec"
					headerType="2"
				></app-title>
				<p class="mat-small">Iniciar sesión</p>
				<app-button
					buttonText="Ingresar"
					(btnClick)="login()"
					color="primary"
				></app-button>
			</div>
		</div>
	</section>
	<section class="dark-tile-container">
		<div>
			<div></div>
			<div class="signup">
				<app-title
					title="¿Aun no tenés cuenta?"
					headerType="2"
					class="dark-tile-content"
				></app-title>
				<p class="mat-small dark-tile-content">Crear una cuenta</p>
				<app-button
					buttonText="Registrarse"
					(btnClick)="login()"
					[isOutlined]="true"
				></app-button>
			</div>
		</div>
		<span></span>
	</section>
</main>
